import { createContext, useContext } from "react";

import { QuickAccessHelper } from "./QuickAccessHelper.ts";

export const QuickAccessContext = createContext<QuickAccessHelper>(
  {} as QuickAccessHelper
);

export const useQuickAccessContext = () => useContext(QuickAccessContext);
